/**
 * FILE-OVERVIEW:
 * - 役割: 共通エラーメッセージ表示コンポーネント。
 * - 主な連携: App.js, 各画面コンテナ
 * - 本番運用上の注意: ユーザー向け文言と内部エラー詳細を混在させない。
 */

import React from 'react';
import { Box, Typography } from '@mui/material';

const ErrorMessage = ({ message }) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      height: '100vh' 
    }}>
      <Typography>{message}</Typography>
    </Box>
  );
};

export default ErrorMessage;